import { localizationData } from '../../config/intlConfig';

export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';

export const switchLanguage = newLang => ({
  type: SWITCH_LANGUAGE,
  payload: localizationData[newLang],
});
